/**
 * Created by h3 on 2017-05-31.
 */


import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TimelineLite, TimelineMax} from "gsap";
import {Tesla} from "../Tesla";
import {TeslaGameConfig} from "../TeslaGameConfig";
import {TeslaSoundConfig} from "../TeslaSoundConfig";

export class TeslaFreeSpinOutroScreenView extends ScreenView {
    // protected timer:CountDownTimer;
    private _textWith:number;

    constructor(onContinueButtonClickCallback:() => void) {
        super({
            layer : TeslaGameConfig.instance.LAYERS.FS_SCREEN.name,
            onButtonClickCallback : onContinueButtonClickCallback,
            mobileScale : 1.2,
            portraitScale : 1.4
        });
    }

    protected createButton():NineSliceButton {
        const text:string = Translation.translate(this._config.buttonText ? this._config.buttonText : "CONTINUE");
        const textStyle:TextStyleOptions = this.getScaledButtonTextStyle();
        textStyle.padding = 10;
        let buttonText = new PIXI.Text(text, textStyle);
        this._textWith = buttonText.width;
        const button = new NineSliceButton(() => this.onButtonClick(), text, textStyle);
        button.enabled = false;
        button.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.7);
        return button;
    }

    protected onButtonClick() {
        this._onButtonClickCallback();
        this.playButtonSound();
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        this.x = 0;
        this.y = 0;
    }


    public show(data:ParsedServerData):void {
        super.show(data);
        this.hideButton();

        let totalWin = data.totalWin;

        const tl:TimelineMax = new TimelineMax();
        tl.add(() => this.addChild(Tesla.freespinScreenAnimation));
        tl.add(Tesla.freespinScreenAnimation.getShowOutroAnimation(totalWin));
        tl.add([
            () => this.showButton()
            // () => this.startAutoCloseTimer()
        ]);
    }

    // public setTimerCompleteCallback(callback:() => void = () => {}):void {
    //     this.timer.completeCallback = callback;
    // }

    // public setTimer(timer:CountDownTimer):void {
    //     this.timer = timer;
    // }

    // private startAutoCloseTimer() {
    //     //this.timer = Tesla.freespinScreenAnimation.timer;
    //     if(!this.timer) {
    //         debugger;
    //         throw new Error("Invalid Timer!");
    //     }
    //
    //     this.timer.time = Math.round(20000 / 1000);
    //     this.timer.start();
    // }

    public getHideOutroAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(Tesla.freespinScreenAnimation.getHideOutroAnimation());
        tl.add(() => this.removeChild(Tesla.freespinScreenAnimation));
        return tl;
    }

    protected onResizeButton(data:IResizeData):void {
        if(data.orientation == Orientation.PORTRAIT) {
            this._button.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.64);
        } else {
            this._button.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.72);
        }

        if(this._textWith < 180) {
            this._button.setSize(200, 70, this._layer.scale.x);
        } else {
            this._button.setSize(this._textWith * 1.20, 70, this._layer.scale.x);
        }
    }

    public hideButton() {
        this._button.enabled = false;
        this.removeChild(this._button);
    }

    private showButton() {
        this._button.enabled = true;
        this.addChild(this._button);
    }

    private playButtonSound() {
        SlotGame.sound.playEffect(TeslaSoundConfig.instance.BUTTON);
    }
}